export function formatDate(dateLike) {
  if (!dateLike) return ''
  const d = new Date(dateLike)
  return d.toLocaleString('en-GB', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
    timeZoneName: 'short',
  })
}
